import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useNavigate, useParams } from 'react-router-dom'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { DownloadInvoiceForm } from '@/components/forms/DownloadInvoiceForm'

export default function DownloadInvoicePage() {
  const navigate = useNavigate()
  const params = useParams<{ shippingLineId: string; invoiceId: string }>()
  const paramsShippingLineId = params.shippingLineId
  const invoiceId = params.invoiceId ? parseInt(params.invoiceId, 10) : undefined

  const finalShippingLineId = paramsShippingLineId
  const finalInvoiceId = invoiceId

  const handleSuccess = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  const handleCancel = () => {
    navigate(`/shipping-lines/financial-statements/${finalShippingLineId}`)
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Download Invoice
            </Heading>
          </CardHeader>
          <CardBody>
            <DownloadInvoiceForm
              invoiceId={finalInvoiceId}
              onSuccess={handleSuccess}
              onCancel={handleCancel}
            />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
